import script from "./RegisterConfirmationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterConfirmationCard.vue?vue&type=script&setup=true&lang=js"

import "./RegisterConfirmationCard.vue?vue&type=style&index=0&id=69bb2794&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69bb2794"]])

export default __exports__